import React, { useEffect, useState } from 'react';
import './EventsPageTable.css'
import { supabase } from '../../supabase';


const BookingPageTable = () => {
    const [booking, setBooking] = useState([]);

    useEffect(()=>{
        const getBooking = async () => {
            const res = await supabase.from('Bookings').select(`id,total_Price,tickets,status,Users:user_ID ( user_Name ),Events:event_ID ( event_Name, event_Date )`)
            setBooking(res.data)
        }

        getBooking();
    } , [])


    return ( 
        <div className='EventsPageTable'>
            <p className='TableName'>All Bookings</p>

            <table>
                <tr className='TopRow'>
                    <th>
                        Booking ID
                    </th>
                    <th>
                        User
                    </th>
                    <th>
                        Event
                    </th>
                    <th>
                        Tickets
                    </th>
                    <th>
                        Total Price
                    </th>
                    <th>
                        Date
                    </th>
                </tr>
                {
                    booking.map((item)=>{
                        return <tr>
                            <td>
                                {item.id}
                            </td>
                            <td>
                                {item.Users?.user_Name}
                            </td>
                            <td>
                                {item.Events?.event_Name}
                            </td>
                            <td>
                                {item.tickets}
                            </td>
                            <td>
                                {item.total_Price}
                            </td>
                            <td>
                                {item.Events?.event_Date}
                            </td>
                            <td>
                                <p className={item.status}>
                                    {item.status}
                                </p>
                            </td>
                        </tr>
                    })
                }
            </table>
        </div>
     );
}
 
export default BookingPageTable;